// deps
import React from "react";

// internal-deps
import { GenericIcon } from "@swiggy-private/dls-web-icons/dist/GenericIconWeb";
import { default as WarningFilledIcon } from "@swiggy-private/dls-web-icons/dist/web/generic/warningFilled/16";
import { IColors } from "@swiggy-private/dls-web-common/dist/components/types.internal";

// styles
import { AlertContainer, IconContainer, StyledText } from "./styles";

interface IAlertBannerProps {
    message: string;
    textColor: keyof IColors;
    backgroundColor: keyof IColors;
    isTurboVariantEnabled?: boolean;
    showIcon?: boolean;
    iconFillColor?: keyof IColors;
}

export const AlertBanner: React.FC<IAlertBannerProps> = ({
    message,
    textColor,
    backgroundColor,
    isTurboVariantEnabled = false,
    showIcon = false,
    iconFillColor,
}) => {
    return (
        <AlertContainer isTurboVariantEnabled={isTurboVariantEnabled} backgroundColor={backgroundColor}>
            {showIcon && (
                <IconContainer>
                    <GenericIcon Icon={WarningFilledIcon} fillColor={iconFillColor} />
                </IconContainer>
            )}
            <StyledText
                variant={"V2.body3.neutral.medium"}
                color={textColor}
                isTurboVariantEnabled={isTurboVariantEnabled}
            >
                {message}
            </StyledText>
        </AlertContainer>
    );
};
